import { createContext, useState } from 'react';

const FilterContext = createContext(null);

function FilterProvider({ children }) {
  const [filterState, setFilterState] = useState({
    loggedin: localStorage.getItem('isLoggedIn') || false,
    username: '',
    id: '',
    role: 'user',
  });

  const [selectedTab, setSelectedTab] = useState(0);

  const handleLogout = () => {
    setFilterState({ loggedin: false, username: '', id: '', role: '' });
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
      enabled: false,
      status: false,
    },
  ]);

  const [finalDate, setFinalDate] = useState({ startDate: null, endDate: null });

  return (
    <FilterContext.Provider
      value={{
        filterState,
        setFilterState,
        handleLogout,
        selectedTab,
        setSelectedTab,
        dateRange,
        setDateRange,
        finalDate,
        setFinalDate,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
}

export { FilterContext, FilterProvider };
